<template>

    <nav class="questions-status">{{ copydeck.label_nav_question }} <span
        class="current-question">{{ currentQuestionIndex }}</span> {{ copydeck.label_nav_question_of }}
        {{ totalQuestionCount }}
    </nav>


    <div class="centered question-image-container" v-if="currentQuestion.image !== ''">
        <div class="skewed-frame--removed-by-martin ">
            <div class="skewed-frame-inner">
                <img :src="currentQuestion.image" class="question-image"/>
            </div>
        </div>
    </div>

    <div class="question-text" :class=" currentQuestion.image !== '' ? 'has-image' : 'no-image' "
         v-html="currentQuestion.data.question"></div>

    <ul class="answers reset-list" v-if="mode === 'answering'">
        <li v-for="answer in currentAnswers" :key="answer.id" class="answer">

            <input type="radio" :id="'answer-' + answer.id" :value="answer.id" v-model="selectedIndex"/>
            <label :for="'answer-' + answer.id" class="button">

                <div class="centered" v-if="answer.image !== ''">
                    <div class="skewed-frame ">
                        <div class="skewed-frame-inner">
                            <img :src="answer.image"/>
                        </div>
                    </div>
                </div>


                <span class="answer-text " v-if=" answer.data.answer !== '' ">{{ answer.data.answer }}</span>

            </label>

        </li>
    </ul>

    <div class="centered submit-container" v-if="mode === 'answering'">
        <button
            :disabled=" typeof selectedIndex === 'undefined' || selectedIndex === null "
            @click="validateAnswer"
            class="button link-show-all white"
        >{{ copydeck.btnValidate }}
        </button>
    </div>

    <ul class="answers reset-list " v-if="mode === 'results'">
        <li v-for="answer in currentAnswers" :key="answer.id" class="answer result">

            <div class="button" :class="answerClass(answer)">

                <div class="centered" v-if="answer.image !== ''">
                    <div class="skewed-frame ">
                        <div class="skewed-frame-inner">
                            <img :src="answer.image"/>
                        </div>
                    </div>
                </div>
                <span class="answer-text " v-if=" answer.data.answer !== ''">{{ answer.data.answer }}</span>

            </div>

        </li>
    </ul>


    <div v-if="mode === 'results' && currentRetroaction !== ''" v-html="currentRetroaction" class="retroaction"></div>

    <div class="centered submit-container">
        <button class="button btn link-show-all white" v-if="mode === 'results' && !isLastQuestion"
                @click="nextQuestion">{{
                copydeck.btnNext
            }}
        </button>
        <button class="button btn link-show-all white" v-if="mode === 'results' && isLastQuestion" @click="showResults">
            {{
                copydeck.btnShowResults
            }}
        </button>
    </div>


</template>

<script setup>

import { ref, computed, onMounted, watch } from 'vue';
import { useStore }                        from "vuex";
import useCopydeck                         from "../composables/UseCopydeck";

let emits = defineEmits( [ "show-screen", "jump-to-top" ] )

//USE
const store                = useStore();
const copydeck             = useCopydeck();
const quiz                 = computed( () => store.state.quiz );
const questions            = ref( quiz.value.questions );
const currentQuestionIndex = ref( 1 );
const totalQuestionCount   = ref( questions.value.length );
const mode                 = ref( "" );
const isLastQuestion       = computed( () => (currentQuestionIndex.value) >= totalQuestionCount.value );


const currentQuestion = computed( () => questions.value[ currentQuestionIndex.value - 1 ] );
const currentAnswers  = computed( () => currentQuestion.value.answers.sort(() => Math.random() - 0.5) );
const selectedIndex   = ref( null );

const currentAnswerIsRight   = computed( () => selectedIndex.value === currentQuestion.value.data.id_answer );
const currentRetroactionType = computed( () => currentAnswerIsRight.value ? "positive" : "negative" );
const currentRetroactions    = computed( () => currentQuestion.value.data.retroactions ?? {
    positive : '',
    negative : '',
} );
const currentRetroaction     = computed( () => currentRetroactions.value[ currentRetroactionType.value ] ?? '' );

function answerClass ( answer )
{
    let isUserAnswer  = answer.id === selectedIndex.value;
    let isRightAnswer = answer.id === currentQuestion.value.data.id_answer;

    if ( isRightAnswer )
    {
        return "right-answer";
    } else if ( isUserAnswer && !isRightAnswer )
    {
        return "wrong-answer";
    }

    return "";
}

function validateAnswer ()
{
    mode.value = "results";

    let isRightAnswer = currentQuestion.value.data.id_answer === selectedIndex.value;

    if ( isRightAnswer )
    {
        store.commit( "rightAnswer" );
    }


    let existingUserAnswers                                       = store.getters.userAnswers;
    existingUserAnswers[ 'question-' + currentQuestion.value.id ] = selectedIndex.value;
    store.commit( "userAnswers", existingUserAnswers );

}

function nextQuestion ()
{
    selectedIndex.value = null;
    currentQuestionIndex.value += 1;
    mode.value = "answering";
    emits( "jump-to-top" );
}

function showResults ()
{
    emits( "jump-to-top" );
    emits( "show-screen", "results" );
}

function mounted ()
{
    selectedIndex.value        = null;
    currentQuestionIndex.value = 1;
    mode.value                 = "answering";
}


onMounted( mounted );

</script>

<style scoped>


</style>
